import ButtonSlideMenu from "./ButtonSlideMenu";
import { POST_TITLE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { useState } from "react";
import ModalCalendar from "../Modal/ModalCalendar/ModalCalendar";
import { Share2 } from "lucide-react";

const ButtonOpenCalendar = () => {
  const [modalCalendarOpen, setModalCalendarOpen] = useState(false);

  const { t } = useTranslationApp();

  return (
    <>
      <ButtonSlideMenu
        id="button-open-calendar"
        startIcon={<Share2 className="w-5 h-5" />}
        onClick={() => setModalCalendarOpen(true)}
      >
        {t(POST_TITLE)}
      </ButtonSlideMenu>
      {modalCalendarOpen && (
        <ModalCalendar
          modalOpen={modalCalendarOpen}
          onCloseModal={() => setModalCalendarOpen(false)}
        />
      )}
    </>
  );
};

export default ButtonOpenCalendar;
